import React, { useEffect, useState, FC } from "react";
import { Button, message, Select, Input, Tooltip } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel from "@/model/navModel";
import { formatNum, getFormValidatorErrText, repairFormatNum } from "@/utils/utils"
import { useAppointmentDetailsModel } from "./appointmentDetailsModels";
import { globalPrompt } from "@/components/message";
import useGlobalModel, { getFindItem, transOptions, vehicleOption, getVehicleItem, vinOption, getVinItem } from "@/model/globalModel";
import { IVehicleFields } from "@/views/base/customerFiles/vehicle/vehicleType";
import { vehicleService } from "@/views/base/customerFiles/vehicle/vehicleService";
import { ITopType } from "@/types/ScmTypes";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { DetailType, IServiceNatureCodeType, IPriceTypeEnum } from "@/types/ScmEnums";
import moment, { Moment } from "moment"
import { debounce, find } from "lodash";
import { useAppointmentModel } from "../../appointmentModel";
import FontIcon from "@/components/YhIcon";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { stockStatisticService } from "@/views/stock/statistic/stockStatisticService";
import { YHDetailNav } from "@/components/YHDetailNav";
import { appointmentService } from "../../appointmentService";

export const FormBox: FC<ITopType> = ({ id, mode, parentInfo, IFormRef }) => {
    const {
        setSelectedRowKeys,
        setDescRows,
        setSelectedRow
    } = useAppointmentModel();
    const { getTreeNodeName } = useDictModel();
    const {
        editDesc,
        verifyGoods,
        detailAddForm,
        detailEditForm,
        detailLookForm,
        updateAddFormVal,
        updateEditFormVal,
        vehicleEditAll, setVehicleEditAll,
        vehicleAddAll, setVehicleAddAll,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        getDetailEditOne,
        transfer,
        detailMaterialAddList, setDetailMaterialAddList,
        detailItemAddList, setDetailItemAddList,
        detailItemEditList, setDetailItemEditList,
        detailMaterialEditList, setDetailMaterialEditList,
        setConsumeHistoryModel,
        setConsumeHistoryVisible,
        setRepairHistoryModel,
        setRepairHistoryVisible,
        formComputeRule,
        saveLoading, setSaveLoading
    } = useAppointmentDetailsModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { beShopDs, CustomerData, shopAndOrg: { shopId, shopCode, shopName, shopType }, allShopDs } = useGlobalModel();
    const { getTreeNodeOne } = useDictModel();
    let { serviceNatureCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm
    const [kmData, setKmData] = useState<string>('')
    const [vehicleVal, setVehicleVal] = useState<boolean>(false)
    const typeForm: any = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    const msgList: any = {
        'M-001': '车辆里程小于上一次保养里程!',
        'M-002': '车辆里程距离上保养里程超过八千公里，该车辆需要做一级保养以及二级保养!',
        'M-003': '车辆里程距离上保养里程超过八千公里，该车辆需要做一级保养以及二级保养!',
        'M-004': '车辆里程距离上保养里程超过三千五百公里，该车辆需要做一级保养!',
        'M-005': '车辆里程距离上次二级保养里程超过八千公里，该车辆需要做二级保养!',
        'M-006': '车辆里程距离上保养里程超过四千公里，该车辆需要做二级保养!',
    }
    useEffect(() => {
        setVehicleVal(false)
        setKmData('')
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode);
            getDetailEditOne(id, mode)
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    useEffect(() => {
        if (typeForm[mode].mileage && vehicleVal) {
            findVehicleDetial(typeForm[mode].licensePlate, typeForm[mode].mileage.toString())
        }
    }, [typeForm[mode].licensePlate])
    useEffect(() => {
        return () => {
            !findNav("3-1") && resetAddCatch(mode);
            !findNav("3-2") && resetEditCatch(mode);
        }
    }, [selectedNavId, shopCode])
    const { getSelectedDictOne } = useDictModel();
    const Options = [
        { label: "整单折扣", value: "1" },
        { label: "维修项目折扣", value: "2" },
        { label: "维修用料折扣", value: "3" }
    ]
    const onDiscount = () => {
        let discountNum: string = "1";
        let discountVal: string = "";

        globalPrompt("modal", {
            width: 380,
            title: "折扣",
            type: "info",
            // text: "",
            text: <>
                <span>请选择折扣类型</span>
                <Select
                    showSearch={true}
                    defaultValue="1"
                    options={Options}
                    onChange={(value, option) => discountNum = value}
                />
                <span>请输入折扣系数</span>
                <Input
                    onChange={(e) => { discountVal = e.target.value }}
                    suffix="%"
                />
            </>,
            okText: "确定",
            onOk: () => {
                var re = /^[0-9]+.?[0-9]*$/;
                return new Promise((resolve, reject) => {
                    if (!re.test(discountVal)) {
                        reject("输入的值不是数字，请重新输入")
                        message.error("输入的值不是数字，请重新输入")

                    } else {
                        resolve(discountVal)
                    }
                }).then(res => {
                    if (discountNum === "1") {
                        onDiscountItem(+discountVal);
                        onDiscountMaterial(+discountVal);
                    } else if (discountNum === "2") {
                        onDiscountItem(+discountVal);
                    } else if (discountNum === "3") {
                        onDiscountMaterial(+discountVal);
                    }
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const onDiscountItem = (discount: number) => {
        let detailsItemList = mode === "add" ? detailItemAddList : detailItemEditList;
        let newDetailsItemList = detailsItemList.map((item) => {
            return {
                ...item,
                discountRate: discount,
                receivableAmount: +formatNum(Number(item.itemAmount) * discount / 100),
            }
        })
        mode === "add" ? setDetailItemAddList(newDetailsItemList) : setDetailItemEditList(newDetailsItemList)
    }

    const onDiscountMaterial = (discount: number) => {
        let detailsMaterialList = mode === "add" ? detailMaterialAddList : detailMaterialEditList;
        let newDetailsMaterialList = detailsMaterialList.map((item) => {
            return {
                ...item,
                discountRate: discount,
                receivableAmount: +formatNum(Number(item.materialAmount) * discount / 100),
            }
        })
        mode === "add" ? setDetailMaterialAddList(newDetailsMaterialList) : setDetailMaterialEditList(newDetailsMaterialList)
    }
    const save = () => {
        if (!verifyGoods(mode)) return;
        if (!formComputeRule(mode)) return;
        IFormRef.current?.validateFields().then(async res => {
            if (res.settlementPartyCode === "settle-party.internal" && !!!res.note) {
                message.warning("结算方为部门内部费用时，备注为必填项，请补齐表单里的备注项");
                return false;
            }
            res.msg = res.msg1 && res.msg2 ? `${res.msg1}|${res.msg2}` : res.msg1 && !res.msg2 ? `${res.msg1}` : ""
            if (mode === "add") {
                const retData = await insertDetail(res)
                if (retData) {
                    globalPrompt("message", { text: "新增成功", type: "success" });
                    setSelectedRowKeys([retData.id as string])
                    setDescRows([retData])
                    setSelectedRow(retData)
                    resetAddCatch(mode)
                    goBack();
                    setSaveLoading(false)
                }
            } else if (mode === "edit") {
                let { receivableAll } = editDesc;
                receivableAll = +repairFormatNum(receivableAll);

                let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailEditForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }
                if (!(customerCode && customerName && payType && settlementPartyCode)) {
                    message.warning("请补全客户名称或结算类型或结算方")
                    return false
                }
                // if (payType !== IVRMSettleTypeEnum.SETTLE_CASH && parentInfo) {
                //     if (!(customerCode && customerName && payType && settlementPartyCode)) {
                //         message.warning("请补全客户名称或结算类型或结算方")
                //         return false
                //     }
                //     let { accountName, availableAmount, isBill, accountCustomerName } = await getSettlementParty({ settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams: getTreeNodeOne(settlementPartyCode as string)[0], bentityCode });
                //     if (accountName && availableAmount >= receivableAll) {//有账户，但是额度大于开单金额的
                //         savsTips(`当前${accountName},授信额度为${availableAmount}是否确认？？`, true, res)
                //     } else if (accountName && availableAmount < receivableAll) { //有账户，但是额度低于开单金额的
                //         savsTips(`当前${accountName},授信额度为${availableAmount}小于开单金额${receivableAll}，无法开单，是否确认？？`, false)
                //     } else if (!accountName) { //查对应没有账户的
                //         savsTips(`当前${accountCustomerName}，无对应账户，无法开单，是否确认？？`, false)
                //     }
                // } else {
                await editSave(res)
                // }
                setSaveLoading(false)
            }
        }).catch(err => {
            setSaveLoading(false)
            message.warning(getFormValidatorErrText(err));
        })
    }
    const savsTips = (info: string, isSave: boolean, from: any = {}) => {
        globalPrompt("modal", {
            title: "预约单转维修单",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => { isSave && await editSave(from) }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const editSave = debounce(async (res: any) => {
        let { id, appointmentCode } = detailEditForm
        const retData = parentInfo ? await transfer({ ...res, id, appointmentCode }) : await editDetail({ ...res, id, appointmentCode })
        if (!!!parentInfo) {
            globalPrompt("message", { text: "编辑成功", type: "success" });
            IFormRef.current?.resetFields()
            getDetailEditOne(appointmentCode as string, mode)
        } else {
            globalPrompt("message", { text: "转接成功", type: "success" });
            replaceNav(selectedNavId, "4-1")

        }
    }, 500)
    const goBack = () => replaceNav(selectedNavId, "3")
    const onRefresh = () => {
        if (mode === "add") {
            IFormRef.current?.resetFields()
            getVehicleAllList()
            resetAddCatch()
        } else if (mode === "edit") {
            IFormRef.current?.resetFields()
            getDetailEditOne(id, mode)
        }
        message.success("刷新成功")
    }
    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && detailEditForm.status === DictCodeEnmu.APPOINTMENT_TRANSFER || detailEditForm.status === DictCodeEnmu.APPOINTMENT_CHANGE) {
            return false;
        }
        return true;
    }
    const rightChildren = <>
        {isMaterialModel() &&
            <>
                <YhAuth resCode={ResourceAuthEnum.AP_ED_DISCOUNT_ALL}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={onDiscount}
                    >快捷折扣</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.AP_PRINT}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        loading={saveLoading}
                        onClick={debounce(() => { save() }, 900)}
                    >{saveLoading ? '保存中' : '保存'}</Button>
                </YhAuth>
            </>
        }
        {mode !== "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onRefresh}
        >刷新</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    //车辆类型
    const vehicleTypeChange = (value: string, option: ISelectOption) => {
        toChooseList({ vehicleTypeCode: option.value })
        option && onChange({ vehicleTypeName: option.label, vehicleTypeCode: option.value });
    }
    //结算方
    const settlementPartyChange = (value: string, option: ISelectOption) => {
        option && onChange({ settlementPartyName: option.label, settlementPartyCode: option.value });
    }
    //结算类型
    const payTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ payTypeName: option.label, payType: option.value });
    }
    //销售实体
    const bentityChange = (value: string, option: ISelectOption) => {
        option && onChange({ bentityName: option.label, bentityCode: option.value });
    }
    //服务性质
    const serviceNatureChange = (value: string, option: ISelectOption) => {
        if (value) {
            toChooseList({ serviceTypeCode: option.value })
            option && onChange({ serviceNatureName: option.label, serviceNatureCode: option.value })
            alterListPrice(typeForm[mode]?.priceTypeCode, value, customerCode as string);
        } else {
            onChange({ serviceNatureName: undefined, serviceNatureCode: undefined });
        }
    }
    const toChooseList = (value: any) => {
        let newData = {
            brandCode: typeForm[mode].brandCode,
            vehicleTypeCode: typeForm[mode].vehicleTypeCode,
            serviceTypeCode: typeForm[mode].serviceNatureCode,
            shopId: typeForm[mode].shopId,
            ...value
        }
        if (newData['brandCode'] && newData['vehicleTypeCode'] && newData['serviceTypeCode']) {
            appointmentService.getChooseList(newData).then((res: any) => {
                if (res.retData) {
                    const { itemDetails, materialDetails, ...form } = res.retData;
                    if (itemDetails.length) {
                        let newList = itemDetails.map((item: any) => {
                            return {
                                ...item,
                                id: "",
                                detailsId: item.id,
                                discountRate: 100,
                                receivableAmount: item.itemAmount,
                            }
                        })
                        mode == 'add' ? setDetailItemAddList([...newList]) : setDetailItemEditList([...newList])
                    }
                    if (materialDetails.length) {
                        let newShelfRows: any[] = [];
                        let str: any = [];
                        materialDetails.forEach((item: any) => {
                            let num: number = item.num ?? 0;
                            let price: number = item.price
                            if (!item.success) {
                                str.push(item.msg)
                            }
                            if (item.repairStockVoList && item.repairStockVoList.length) {
                                const tempArr = item.repairStockVoList
                                for (let i = 0; i < tempArr.length; i++) {
                                    let goods = tempArr[i];
                                    // 公共字段
                                    let publicData = {
                                        id: "",
                                        key: goods.id,
                                        discountRate: 100,
                                        inventoryNum: goods.inventoryNum,
                                        materialCode: goods.materialCode,
                                        materialName: goods.materialName,
                                        num: goods.availableStock,
                                        price: item.salePrice,
                                        // lateSalePrice: price,
                                        materialAmount: +formatNum((goods.availableStock as number) * (item.salePrice as number)),
                                        receivableAmount: +formatNum((goods.availableStock as number) * (item.salePrice as number) / 100),
                                        stockId: goods.id,
                                        detailsId: goods.id,
                                        purchaseId: goods.id,
                                        purchaseCode: goods.purchaseCode,
                                        warehouseCode: goods.warehouseCode,
                                        warehouseName: goods.warehouseName,
                                        shelfCode: goods.shelfCode,
                                        vehicleModel: goods.vehicleModel,
                                        model: goods.model,
                                        unitName: goods.unitName,
                                        unitCode: goods.unitCode,
                                        brandCode: goods.brandCode,
                                        brandName: goods.brandName,
                                        latestPurPrice: goods.price
                                    }
                                    // 可用库存 = 库存数量 - 占用库存
                                    let kynum = goods.inventoryNum - goods.inventoryOccupied;
                                    //当匹配到最后一个配件, 可用库存不满足用户填写数量, 那就设置该配件为异常配件, 数量设置为减完前面配件可用库存剩余的数量
                                    if (i === tempArr.length - 1 && kynum < num) {
                                        newShelfRows.push({
                                            ...publicData,
                                        })
                                        break
                                    }
                                    if (num <= 0) break;
                                    if (kynum) {
                                        num = num - kynum;
                                        // 当 可用数量 小于
                                        let tempNum = num < 0 ? kynum + num : kynum;
                                        newShelfRows.push({
                                            ...publicData,
                                            num: tempNum,
                                            materialAmount: +formatNum((goods.availableStock as number) * (tempNum as number)),
                                            receivableAmount: +formatNum((goods.availableStock as number) * (tempNum as number) / 100),
                                        })
                                    }
                                }
                            }
                        })
                        str.length !== 0 && globalPrompt('message', { text: `${str.join(',')}`, type: 'warning' })
                        mode == 'add' ? setDetailMaterialAddList([...newShelfRows]) : setDetailMaterialEditList([...newShelfRows])

                    }
                } else {
                    mode == 'add' ? setDetailItemAddList([]) : setDetailItemEditList([])
                    mode == 'add' ? setDetailMaterialAddList([]) : setDetailMaterialEditList([])
                }
            })
        }

    }
    //售价选择
    const priceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ priceTypeName: option.label, priceTypeCode: option.value });
        if (value) {
            alterListPrice(value, serviceNatureCode as string, customerCode as string);
        }
    }
    //from销售类型，售价选择时更改 详情表格的价格信息
    const alterListPrice = async (priceTypeCode: string | undefined, serviceNatureCode: string, customerCode: string) => {
        let detailsList = mode == "add" ? detailMaterialAddList : detailMaterialEditList;
        if (!detailsList.length) return;
        if (!serviceNatureCode || !customerCode) {
            message.warning("请补全客户名称，维修类型才可以，对下列表格的价格数据进行更改");
            return false;
        }
        let newDetailsList = await Promise.all(detailsList.map(async (item: any) => {
            let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, purchasePrice, retailPrice, num, ...params } = item as { latestPurPrice: number, lateSalePrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, stockId: string }
            let newPrice: number = 0;

            if (!(serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN)) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                        newPrice = +price;
                        break;
                    //售价选择 最近销价 
                    case IPriceTypeEnum.RECENT:
                        newPrice = await findPoDetailPrice(stockId, ["lateSalePrice", "retailPrice"], true)
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        newPrice = await findPoDetailPrice(stockId, ["retailPrice"])
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = await findPoDetailPrice(stockId, ["purchasePrice"])
                        break;
                }
            } else {
                newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)// latestPurPrice ?? purchasePrice
            }

            return {
                ...item,
                num,
                discountRate,
                price: newPrice,
                materialAmount: +formatNum(num * newPrice),
                receivableAmount: +formatNum((num * newPrice * discountRate) / 100)
            }
        }))
        mode === "add" ? setDetailMaterialAddList(newDetailsList) : setDetailMaterialEditList(newDetailsList);
    }
    //根据销售类型，售价选择去查询采购明细对应的单价
    const findPoDetailPrice = async (stockId: string, priceType: string[], priceTypeLen?: boolean) => {
        let resultPrice: number = 0;
        await stockStatisticService.findId(stockId).then(async res => {
            let retData = await res.retData;
            resultPrice = priceTypeLen ? retData?.[priceType[0]] ?? retData?.[priceType[1]] : retData?.[priceType[0]];

        })
        return resultPrice
    }
    //服务地点
    const serviceLocationChange = (value: string, option: ISelectOption) => {
        option && onChange({ serviceLocationName: option.label, serviceLocationCode: option.value });
    }

    //所属站点
    const shopNameChange = (value: string, option: ISelectOption) => {
        option && onChange({ shopId: option.value, shopCode: option.code, shopName: option.label });
    }

    useEffect(() => {
        getVehicleAllList()
    }, [mode])

    const getVehicleAllList = async (param?: IVehicleFields) => {
        let params = {
            ...param,
            shopId,
            pageSize: 2000,
            pageNum: 1
        }
        const { retData } = await vehicleService.pages(params)
        const { records } = retData
        if (records.length === 0) { globalPrompt("message", { text: "该客户下没有车辆，点击左侧车辆牌照去新增吧!", type: "warning" }) }
        let newRecords = records.map(item => {
            return {
                ...item,
                label: item.licensePlate,
                value: item.licensePlate
            }
        })
        mode === "add" ? setVehicleAddAll(newRecords) : setVehicleEditAll(newRecords)

    }
    //客户名称
    const customerChange = (value: string, option: ISelectOption) => {
        if (value && option) {
            let { name, code, contact, phone, address, categoryCode, categoryName } = getFindItem(value, CustomerData)
            option && onChange({
                customerName: option.label,
                customerCode: option.value,
                contact,
                phone,
                customerAddress: address,
                customerTypeCode: categoryCode,
                customerTypeName: categoryName,
                licensePlate: null,
                vehicleTypeCode: null,
                vehicleTypeName: null,
                vehicleModel: null,
                vin: null
            });
        }
        toChooseList({ vehicleTypeCode: null })
        getVehicleAllList({ customerCode: option?.value as string })

    }
    //车辆牌照
    const vehicleChange = async (value: string, option: ISelectOption) => {
        let VehicleIList: any = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {
            setVehicleVal(true)
            let data = getVehicleItem(value, VehicleIList)
            let { customerName, customerCode, licensePlate, brandCode, brandName, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName, model, tonnage, vehicleNumber } = data
            console.log(data);
            option && onChange({
                customerName,
                customerCode,
                contact,
                phone,
                customerAddress: address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                vehicleModel: model,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
                brandCode,
                brandName,
                tonnage,
                vehicleNumber,
            });
            toChooseList({ vehicleTypeCode: categoryCode, brandCode })
        }

    }
    //vin码
    const vinChange = (value: string, option: ISelectOption) => {
        let VehicleIList: any = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {

            let { customerName, customerCode, licensePlate, brandCode, brandName, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName, model } = getVinItem(value, VehicleIList)
            option && onChange({
                customerName,
                customerCode,
                contact,
                phone,
                customerAddress: address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                vehicleModel: model,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
            });
        }
    }

    const goCustomer = () => {
        replaceNav(
            selectedNavId,
            "13-5-1-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const goVehicle = () => {
        replaceNav(
            selectedNavId,
            "13-5-2-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id,
                    customerCode: typeForm[mode].customerCode
                }
            },
            true)
    }
    const disabledDate = (current: Moment) => {
        return current && current < moment(detailAddForm.enterTime)
    }
    //品牌
    const brandCodeChange = (value: string, option: ISelectOption) => {
        toChooseList({ brandCode: option.value })
        option && onChange({ brandName: option.label, brandCode: option.value });
    }
    const findVehicleDetial = async (licensePlate: string, mileage: string) => {
        let newParams = {
            licensePlate,
            mileage,
            createTime: mode === "edit" ? typeForm[mode].createTime : ""
        }
        let { retData } = await appointmentService.findVehicleDetial(newParams)
        if (retData) {
            if (msgList[retData.code] !== typeForm[mode].msg1) {
                if (retData.code == "M-001") {
                    let auditReason: string = ""
                    globalPrompt("modal", {
                        title: "提交里程原因:",
                        type: "success",
                        text: <><span style={{ color: 'red', lineHeight: '35px' }}>{retData.msg}</span>
                            <Input onChange={(e) => { auditReason = e.target.value }} /></>,
                        okText: "确定",
                        onOk: async () => {
                            onChange({ msg1: msgList[retData.code], msg2: auditReason })
                            message.success("提交成功");
                        },
                        cancelText: "取消",
                        onCancel: () => {
                        }
                    })
                } else {
                    message.warning(retData.msg);
                    onChange({ msg1: msgList[retData.code], msg2: undefined })
                }
            }
        }
        else {
            onChange({ msg1: undefined, msg2: undefined })
        }
    }
    const onConsumption = () => {
        let { customerCode, customerName } = typeForm[mode]
        if (!customerCode) {
            return message.warning("请先选择客户")
        }
        setConsumeHistoryVisible(true)
        setConsumeHistoryModel({ customerName: customerName as string })
    }
    const onRepairHistory = () => {
        let { licensePlate } = typeForm[mode]
        if (!licensePlate) {
            return message.warning("请先选择车辆")
        }
        setRepairHistoryVisible(true)
        setRepairHistoryModel({ licensePlate: licensePlate })
    }
    const onBlur = async (e: any) => {
        let data: number = Number(e.target.value) ?? 0
        data = isNaN(data) ? 0 : data;
        if (kmData !== data.toString()) {
            setKmData(data.toString())
            if (data && typeForm[mode].licensePlate) {
                await findVehicleDetial(typeForm[mode].licensePlate, data.toString())
            }
        }
    }
    const title = <>
        <span>基础信息</span>
        <Tooltip placement="topLeft" title="消费记录">
            <FontIcon type="icon-xiaofeijilu" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onConsumption}
            />
        </Tooltip>
        <Tooltip placement="topLeft" title="维修历史">
            <FontIcon type="icon-ic_history" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onRepairHistory}
            />
        </Tooltip>
        <a className="color-blue" style={{ float: 'right', fontSize: '17px' }} onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>
    </>
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        // rightChildren,
        items: [
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "预约单号",
            //     fieldName: "appointmentCode",
            //     disable: true,
            //     placeholder: "自动生成",
            // }, 
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="click-span" onClick={goCustomer}>客户名称</span>,
                fieldName: "customerCode",
                options: transOptions(CustomerData),
                onSelectChange: customerChange,
                allowClear: true,
                showSearch: true,
                rules: [{ required: true, message: "请选择客户" }],
                hidden: mode === "look"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: mode !== "look"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送修人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入送修人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送车电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入送车电话" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "brandName",
                fieldName: "brandName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "维修类型",
                fieldName: "serviceNatureCode",
                options: getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE),
                onSelectChange: serviceNatureChange,
                rules: [{ required: true, message: "维修类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="click-span" onClick={goVehicle}>车辆牌照</span>,
                fieldName: "licensePlate",
                allowClear: true,
                showSearch: true,
                options: mode === "add" ? vehicleOption(vehicleAddAll) : vehicleOption(vehicleEditAll),
                onSelectChange: vehicleChange,
                rules: [{ required: true, message: "请输入车牌号" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "所属站点",
                fieldName: "shopId",
                options: allShopDs,
                showSearch: false,
                onSelectChange: shopNameChange,
                rules: [{ required: true, message: "请选择所属站点" }],
                disable: shopType === 0 && mode == 'add' ? false : true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "shopName",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆里程",
                fieldName: "mileage",
                // onInputBlur: onBlur,
                suffix: <span style={{ color: "#6C72F3" }}>KM</span>,
                rules: [{ required: true, message: "请输入车辆里程" }],
                waring: typeForm[mode].msg1
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "故障描述",
                fieldName: "faultDesc",
                detialVal: typeForm[mode].faultDesc
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "服务地点",
                fieldName: "serviceLocationCode",
                onSelectChange: serviceLocationChange,
                options: getSelectedDictOne(DictCodeEnmu.SERVICE_ADDRESS),
                rules: [{ required: true, message: "请选择服务地点" }],
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "预约进厂时间",
                showTime: true,
                fieldName: "enterTime",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "车辆品牌",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_BRAND),
                fieldName: "brandCode",
                onSelectChange: brandCodeChange,
                rules: [{ required: true, message: "请输入车辆品牌" }]
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "车辆类型",
                fieldName: "vehicleTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
                onSelectChange: vehicleTypeChange,
                rules: [{ required: true, message: "请输入车辆类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "VIN码",
                fieldName: "vin",
                allowClear: true,
                showSearch: true,
                onSelectChange: vinChange,
                options: mode === "add" ? vinOption(vehicleAddAll) : vinOption(vehicleEditAll),
                hidden: more,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "吨位",
                fieldName: "tonnage",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆编号",
                fieldName: "vehicleNumber",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "外修原因",
                fieldName: "outsideReason",
                hidden: more
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆型号",
                fieldName: "vehicleModel",
                hidden: more
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityCode",
                options: beShopDs,
                allowClear: true,
                showSearch: true,
                onSelectChange: bentityChange,
                hidden: more,
                disable: true,
                rules: [{ required: true, message: "请选择销售实体" }]
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "结算方",
                fieldName: "settlementPartyCode",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_PARTY),
                onSelectChange: settlementPartyChange,
                hidden: more || mode === "look",
                // disable: true,
                rules: [{ required: true, message: "请选择结算方" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方",
                fieldName: "settlementPartyName",
                hidden: more || mode !== "look"
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "结算类型",
                fieldName: "payType",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                onSelectChange: payTypeChange,
                hidden: more || mode === "look",
                disable: true,
                rules: [{ required: true, message: "请选择结算类型" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算类型",
                fieldName: "payTypeName",
                hidden: more || mode !== "look"
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工作小时",
                fieldName: "workingHours",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "处理意见",
                fieldName: "faultResult",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户地址",
                fieldName: "customerAddress",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "待修内容",
                fieldName: "toBeRepaired",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "下次保养时间",
                fieldName: "nextMaintainTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "预约出厂时间",
                showTime: true,
                fieldName: "deliveryTime",
                disabledDate: disabledDate,
                hidden: more
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "售价选择",
                fieldName: "priceTypeCode",
                // disable: serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J,
                options: getSelectedDictOne(DictCodeEnmu.PRICE_SELECTION),
                hidden: more,
                disable: true,
                onSelectChange: priceTypeChange,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                hidden: more
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "里程原因",
                fieldName: "msg2",
                disable: true,
                hidden: more,
                detialVal: typeForm[mode].msg2
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "里程原因",
                fieldName: "msg1",
                disable: true,
                hidden: true,
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售实体名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆类型Name",
                fieldName: "vehicleTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修类型Name",
                fieldName: "maintenanceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方Name",
                fieldName: "settlementPartyName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方式Name",
                fieldName: "paymentMethodName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户类型Name",
                fieldName: "customerTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型Name",
                fieldName: "invoiceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "服务类型Name",
                fieldName: "serviceNatureName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "服务地点Name",
                fieldName: "serviceLocationName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "售价选择Name",
                fieldName: "priceTypeName",
                hidden: true
            }
        ]
    };
    const onChange = (changedValues: { [key: string]: any }) => {
        mode === "add" ? updateAddFormVal(changedValues) : updateEditFormVal(changedValues)
    }
    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelAlign: "right",
        disabled: !isMaterialModel(),
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        预约单号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode].appointmentCode ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}